import { presentationsNamespace } from 'streams/presentations/presentations$';
import { defaultState, reducers } from './reducers';
import { persistentReducedStream } from '@ardoq/rxbeach';

const presentationsOverview$ = persistentReducedStream(
  'presentationsOverview$',
  defaultState,
  reducers,
  { namespace: presentationsNamespace }
);

export { presentationsOverview$ };
